import { render, staticRenderFns } from "./m-editShortAnswer.vue?vue&type=template&id=6cc875c7&"
import script from "./m-editShortAnswer.vue?vue&type=script&lang=js&"
export * from "./m-editShortAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports